import { createRouteRef } from '@backstage/core-plugin-api';

export const cicdPromoterRouteRef = createRouteRef({
  id: 'cicd-promoter',
});
